import { getClient } from "@/lib/apollo";
import { STAFF_LOGIN, LOGOUT_SESSION, GOOGLE_OAUTH_LOGIN } from "./mutation";
import { RESET_PASSWORD, CONFIRM_RESET_PASSWORD } from "../profile/mutation";

export const staffLogin = (email: string, password: string, otp?: string) =>
  getClient().mutate({
    mutation: STAFF_LOGIN,
    variables: {
      email,
      password,
      otp,
    },
  });

export const adminLogin = staffLogin;

export const googleOAuthLogin = (accessToken: string) =>
  getClient().mutate({
    mutation: GOOGLE_OAUTH_LOGIN,
    variables: {
      accessToken,
    },
  });

export const staffLogout = (sessionKey?: string) =>
  getClient().mutate({
    mutation: LOGOUT_SESSION,
    variables: {
      sessionKey,
    },
  });

export const adminLogout = staffLogout;

export const resetPassword = (email: string, areaType: string = "staff") =>
  getClient().mutate({
    mutation: RESET_PASSWORD,
    variables: {
      email,
      areaType,
    },
  });

export const resetPasswordConfirm = (
  password: string,
  token: string,
  uuid: string
) =>
  getClient().mutate({
    mutation: CONFIRM_RESET_PASSWORD,
    variables: {
      password,
      token,
      uuid,
    },
  });
